// Centralized data-testid registry for Lendly
export const NAV = {
    root: "global-navbar",
    logo: "nav-logo-link",
    howItWorks: "nav-how-it-works-link",
    browse: "nav-browse-link",
    listItem: "nav-list-item-link",
    myRentals: "nav-my-rentals-link",
    myListings: "nav-my-listings-link",
    messages: "nav-messages-link",
    login: "nav-login-btn",
    signup: "nav-signup-btn",
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
};

export const MESSAGES = {
    page: "messages-page",
    list: "messages-list",
    empty: "messages-empty",
    row: (id) => `messages-row-${id}`,
    unreadBadge: (id) => `messages-unread-${id}`,
    threadModal: "message-thread-modal",
    threadClose: "message-thread-close",
    replyInput: "message-thread-reply-input",
    replySend: "message-thread-reply-send",
    message: (id) => `message-item-${id}`,
};

export const LANDING = {
    root: "landing-page",
    hero: "landing-hero",
    heroBrowseCta: "hero-browse-cta",
    heroListCta: "hero-list-cta",
    howItWorks: "landing-how-it-works",
    howStep: (i) => `how-step-${i}`,
    whyLendly: "landing-why-lendly",
    benefit: (i) => `benefit-${i}`,
    trust: "landing-trust",
    trustItem: (i) => `trust-item-${i}`,
    finalCta: "landing-final-cta",
    finalCtaBrowse: "final-cta-browse",
    finalCtaList: "final-cta-list",
};

export const BROWSE = {
    root: "browse-page",
    searchInput: "browse-search-input",
    categorySelect: "browse-category-select",
    minPriceInput: "browse-min-price-input",
    maxPriceInput: "browse-max-price-input",
    availabilityToggle: "browse-availability-toggle",
    clearFilters: "browse-clear-filters",
    grid: "browse-items-grid",
    itemCard: (id) => `browse-item-card-${id}`,
    itemCardView: (id) => `browse-item-view-${id}`,
    emptyState: "browse-empty-state",
    loading: "browse-loading",
    resultsCount: "browse-results-count",
};

export const ITEM_MODAL = {
    root: "item-detail-modal",
    title: "item-detail-title",
    image: "item-detail-image",
    description: "item-detail-description",
    condition: "item-detail-condition",
    price: "item-detail-price",
    owner: "item-detail-owner",
    daysInput: "item-detail-days-input",
    requestBtn: "item-detail-request-btn",
    feeBreakdown: "item-detail-fee-breakdown",
    close: "item-detail-close",
};

export const CHECKOUT = {
    successRoot: "checkout-success-page",
    cancelRoot: "checkout-cancel-page",
    statusBadge: "checkout-status-badge",
    receipt: "checkout-receipt",
    goRentalsBtn: "checkout-go-rentals-btn",
    goBrowseBtn: "checkout-go-browse-btn",
    retryBtn: "checkout-retry-btn",
};

export const MY_RENTALS = {
    root: "my-rentals-page",
    authGate: "my-rentals-auth-gate",
    statTotal: "rentals-stat-total",
    statActive: "rentals-stat-active",
    statSpent: "rentals-stat-spent",
    sectionActive: "rentals-section-active",
    sectionUpcoming: "rentals-section-upcoming",
    sectionPast: "rentals-section-past",
    row: (id) => `rentals-row-${id}`,
    emptyState: "rentals-empty-state",
    browseBtn: "rentals-browse-more-btn",
    loading: "rentals-loading",
};

export const LIST_ITEM = {
    root: "list-item-page",
    authGate: "list-item-auth-gate",
    stepper: "list-item-stepper",
    stepIndicator: (i) => `list-item-step-${i}`,
    // Step 1 — basics
    nameInput: "list-item-name-input",
    categorySelect: "list-item-category-select",
    descriptionInput: "list-item-description-input",
    conditionSelect: "list-item-condition-select",
    // Step 2 — pricing & pickup
    priceInput: "list-item-price-input",
    priceSuggestion: "list-item-price-suggestion",
    priceUseSuggestion: "list-item-price-use-suggestion",
    depositInput: "list-item-deposit-input",
    availStart: "list-item-availability-start",
    availEnd: "list-item-availability-end",
    locationInput: "list-item-location-input",
    pickupInput: "list-item-pickup-input",
    // Step 3 — photos
    photoUploadInput: "list-item-photo-upload",
    photoDropzone: "list-item-photo-dropzone",
    photoThumb: (i) => `list-item-photo-thumb-${i}`,
    photoRemove: (i) => `list-item-photo-remove-${i}`,
    // Step 4 — preview
    preview: "list-item-preview",
    // Nav
    backBtn: "list-item-back-btn",
    nextBtn: "list-item-next-btn",
    publishBtn: "list-item-publish-btn",
};

export const MY_LISTINGS = {
    root: "my-listings-page",
    authGate: "my-listings-auth-gate",
    headerEarnings: "listings-lifetime-earnings",
    statListed: "listings-stat-items-listed",
    statCompleted: "listings-stat-rentals-completed",
    statRevenue: "listings-stat-total-revenue",
    statActive: "listings-stat-active-rentals",
    tabAll: "listings-tab-all",
    tabActive: "listings-tab-active",
    tabRented: "listings-tab-rented",
    tabPaused: "listings-tab-paused",
    list: "listings-list",
    row: (id) => `listings-row-${id}`,
    rowStatus: (id) => `listings-row-status-${id}`,
    rowRentals: (id) => `listings-row-rentals-${id}`,
    rowRevenue: (id) => `listings-row-revenue-${id}`,
    rowEdit: (id) => `listings-row-edit-${id}`,
    rowPause: (id) => `listings-row-pause-${id}`,
    rowDelete: (id) => `listings-row-delete-${id}`,
    emptyState: "listings-empty-state",
    loading: "listings-loading",
    listItemCta: "listings-list-item-cta",
};

export const EDIT_MODAL = {
    root: "edit-listing-modal",
    name: "edit-name-input",
    description: "edit-description-input",
    category: "edit-category-select",
    price: "edit-price-input",
    location: "edit-location-input",
    condition: "edit-condition-select",
    image: "edit-image-input",
    save: "edit-save-btn",
    cancel: "edit-cancel-btn",
};

export const DELETE_DIALOG = {
    root: "delete-listing-dialog",
    confirm: "delete-listing-confirm-btn",
    cancel: "delete-listing-cancel-btn",
};

export const AUTH_GATE = {
    root: "auth-gate",
    signInBtn: "auth-gate-sign-in-btn",
};

export const AUTH = {
    loginPage: "login-page",
    signupPage: "signup-page",
    googleBtn: "auth-google-btn",
    emailForm: "auth-email-form",
    nameInput: "auth-name-input",
    emailInput: "auth-email-input",
    passwordInput: "auth-password-input",
    showPasswordToggle: "auth-show-password-toggle",
    submitBtn: "auth-submit-btn",
    error: "auth-error",
    switchModeLink: "auth-switch-mode-link",
    forgotLink: "auth-forgot-link",
    forgotPage: "forgot-password-page",
    forgotForm: "forgot-password-form",
    forgotEmailInput: "forgot-password-email-input",
    forgotSubmit: "forgot-password-submit-btn",
    forgotSuccess: "forgot-password-success",
    resetPage: "reset-password-page",
    resetForm: "reset-password-form",
    resetPasswordInput: "reset-password-input",
    resetConfirmInput: "reset-password-confirm-input",
    resetSubmit: "reset-password-submit-btn",
    resetSuccess: "reset-password-success",
    resetInvalid: "reset-password-invalid",
};

export const AVAILABILITY = {
    calendar: (mode) => `availability-calendar-${mode || "view"}`,
    dayCell: (date) => `availability-day-${date}`,
    range: "availability-range-label",
    rangeReset: "availability-range-reset",
    legend: "availability-legend",
    saveBtn: "availability-save-btn",
    blockedCount: "availability-blocked-count",
};

export const FOOTER = {
    root: "global-footer",
};

export const NEIGHBOR = {
    root: "neighbor-profile-page",
    backBtn: "neighbor-back-btn",
    name: "neighbor-name",
    avatar: "neighbor-avatar",
    statItems: "neighbor-stat-items",
    statRentals: "neighbor-stat-rentals",
    statRating: "neighbor-stat-rating",
    statReviews: "neighbor-stat-reviews",
    listingsGrid: "neighbor-listings-grid",
    listingsEmpty: "neighbor-listings-empty",
    reviewsList: "neighbor-reviews-list",
    reviewsEmpty: "neighbor-reviews-empty",
    reviewItem: (id) => `neighbor-review-${id}`,
    loading: "neighbor-loading",
    notFound: "neighbor-not-found",
};

export const REVIEW_MODAL = {
    root: "review-modal",
    rentalLabel: "review-modal-rental",
    star: (n) => `review-modal-star-${n}`,
    comment: "review-modal-comment",
    submit: "review-modal-submit",
    cancel: "review-modal-cancel",
};

export const RENTAL_REVIEW = {
    cta: (rentalId) => `rental-review-cta-${rentalId}`,
    edit: (rentalId) => `rental-review-edit-${rentalId}`,
    display: (rentalId) => `rental-review-display-${rentalId}`,
};

export const RETURN_RENTAL = {
    cta: (rentalId) => `rental-return-cta-${rentalId}`,
    modal: "return-rental-modal",
    note: "return-rental-note",
    photoUpload: "return-rental-photo-upload",
    photoThumb: (i) => `return-rental-photo-thumb-${i}`,
    photoRemove: (i) => `return-rental-photo-remove-${i}`,
    submit: "return-rental-submit",
    cancel: "return-rental-cancel",
    returnedSection: "my-listings-recent-returns",
    returnedRow: (rentalId) => `recent-return-${rentalId}`,
    afterGallery: (rentalId) => `return-photos-after-${rentalId}`,
    acceptBtn: (rentalId) => `return-accept-${rentalId}`,
    pendingBadge: (rentalId) => `return-pending-badge-${rentalId}`,
};

export const DEPOSIT = {
    statusBadge: (rentalId) => `deposit-status-${rentalId}`,
    releaseBtn: (rentalId) => `deposit-release-${rentalId}`,
    withholdBtn: (rentalId) => `deposit-withhold-${rentalId}`,
    withholdModal: "deposit-withhold-modal",
    withholdReason: "deposit-withhold-reason",
    withholdSubmit: "deposit-withhold-submit",
    withholdCancel: "deposit-withhold-cancel",
};

export const DISPUTE = {
    openBtn: (rentalId) => `dispute-open-${rentalId}`,
    viewBtn: (rentalId) => `dispute-view-${rentalId}`,
    modal: "dispute-thread-modal",
    openMessage: "dispute-open-message",
    openSubmit: "dispute-open-submit",
    threadList: "dispute-thread-messages",
    threadMessage: (i) => `dispute-message-${i}`,
    reply: "dispute-reply-input",
    replySubmit: "dispute-reply-submit",
    resolveBtn: "dispute-resolve-btn",
    resolveNote: "dispute-resolve-note",
    resolveSubmit: "dispute-resolve-submit",
    badge: (rentalId) => `dispute-badge-${rentalId}`,
};
